import { Box, LinearProgress } from '@mui/material'
import './ProgressBar.css'

type Props = {
  manualPercentage: number[]
  className?: string
}

export const ProgressBar = ({ manualPercentage, className = '' }: Props) => {
  return (
    <Box className={`a-progress-container ${className}`}>
      {manualPercentage.map((section, index) => (
        <LinearProgress
          key={`progres-section-${section}-${index}`}
          variant="determinate"
          value={section}
          className="a-progress-section"
        />
      ))}
    </Box>
  )
}
